const CONTRACT_SENT_NOTE_REGEX =
	/^Contract sent to (?<signerName>.+?) <(?<signerEmail>[^>]+)> \| Sent at: (?<sentAt>[^|]+) \| Envelope ID: (?<envelopeId>.+)$/;

function readStringValue(value) {
	return typeof value === 'string' ? value.trim() : '';
}

function getTimeValue(value) {
	if (!value) {
		return 0;
	}

	const parsed = new Date(value).getTime();
	return Number.isNaN(parsed) ? 0 : parsed;
}

export function buildContractSentNote({
	envelopeId,
	signerName,
	signerEmail,
	sentAt = new Date().toISOString(),
	userId = '',
}) {
	const resolvedEnvelopeId = readStringValue(envelopeId);
	const resolvedSignerName = readStringValue(signerName) || 'Unknown signer';
	const resolvedSignerEmail = readStringValue(signerEmail);
	const resolvedSentAt = readStringValue(sentAt) || new Date().toISOString();

	return {
		userId,
		createdAt: resolvedSentAt,
		text: `Contract sent to ${resolvedSignerName} <${resolvedSignerEmail}> | Sent at: ${resolvedSentAt} | Envelope ID: ${resolvedEnvelopeId}`,
		attachments: [],
	};
}

export function parseContractSentNote(note) {
	if (!note || typeof note !== 'object') {
		return null;
	}

	const envelopeId = readStringValue(note.envelopeId);
	const signerName = readStringValue(note.signerName);
	const signerEmail = readStringValue(note.signerEmail);
	const sentAt = readStringValue(note.sentAt) || readStringValue(note.createdAt);

	if (envelopeId && signerEmail) {
		return {
			envelopeId,
			signerName,
			signerEmail,
			sentAt,
			createdAt: readStringValue(note.createdAt) || sentAt,
			note,
		};
	}

	const text = readStringValue(note.text);
	const match = text.match(CONTRACT_SENT_NOTE_REGEX);

	if (!match?.groups) {
		return null;
	}

	return {
		envelopeId: readStringValue(match.groups.envelopeId),
		signerName: readStringValue(match.groups.signerName),
		signerEmail: readStringValue(match.groups.signerEmail),
		sentAt: readStringValue(match.groups.sentAt),
		createdAt: readStringValue(note.createdAt) || readStringValue(match.groups.sentAt),
		note,
	};
}

export function getLatestContractSentEvent(notes = []) {
	if (!Array.isArray(notes) || notes.length === 0) {
		return null;
	}

	return notes.reduce((latestEvent, note) => {
		const currentEvent = parseContractSentNote(note);

		if (!currentEvent) {
			return latestEvent;
		}

		if (!latestEvent) {
			return currentEvent;
		}

		const currentTime = getTimeValue(currentEvent.sentAt || currentEvent.createdAt);
		const latestTime = getTimeValue(latestEvent.sentAt || latestEvent.createdAt);

		return currentTime >= latestTime ? currentEvent : latestEvent;
	}, null);
}
